<template>
  <div>
        <!--  Add v-if="!isFormSend" to form below to add thank-you image -->
    <form @submit.prevent="submit" >
      <div class="header-form">
        <div class="header-form-big-header">Looks like you are ready to start!</div>
        <div class="header-form-small-header">Let’s get in touch!</div>
        <div class="input-box">
          <div class="header-input-container">
            <input
              type="text"
              v-model.trim="$v.name.$model"
              class="header-input"
              placeholder="Name"
              :style="$v.name.$error ? 'border: 2px solid #DF7B7B;' : null"
              :class="$v.name.$invalid ? '' : 'header-with-text'"
              @input="delayTouch($v.name)"
              maxlength="50"
            />
            <span v-if="$v.name.$error" style class="header-form-error">Please, enter your Name</span>
          </div>
          <div class="header-input-container">
            <vue-tel-input
              type="tel"
              v-bind="bindProps2"
              :style="$v.phoneNumber.$error ? 'border: 2px solid #DF7B7B;' : null"
              v-model.trim="$v.phoneNumber.$model"
              class="header-input"
              placeholder="Phone"
              :class="$v.phoneNumber.$invalid ? '' : 'header-with-text'"
              maxlength="16"
              @input="delayTouch($v.phoneNumber)"
              mask="+FFFFFFFFFFFF"
              :tokens="hexTokens"
            />

            <span v-if="$v.phoneNumber.$error" class="header-form-error">Please, enter valid Phone number</span>
          </div>
          <div class="header-input-container">
            <input
              :style="$v.email.$error ? 'border: 2px solid #DF7B7B;' : null"
              type="text"
              class="header-input"
              placeholder="Email"
              v-model.trim="$v.email.$model"
              @input="delayTouch($v.email)"
              :class="$v.email.$invalid ? '' : 'header-with-text'"
              maxlength="50"
            />
            <span v-if="$v.email.$error" style class="header-form-error">Please, enter valid Email</span>
          </div>
        </div>
        <button class="header-form-btn" type="submit">send</button>
      </div>
    </form>
    <!-- <div v-else class="form-send">
      <img :src="formSend" alt class="header-form-letter" />
    </div> -->
  </div>
</template>

<script src="https://code.jquery.com/jquery-3.4.1.min.js"></script>
<script>
import { formSend } from "../configs/form";
import { VueTelInput } from '../components/vue-tel-input/dist/vue-tel-input.esm'
import {
  required,
  maxLength,
  minLength,
  email
} from "vuelidate/lib/validators";
import $ from 'jquery';
import axios from "axios";
import { TheMask } from "vue-the-mask";
import authHeader from './../utils/getAuthEmailHeader';

export default {
  name: "form",
  components: {
    TheMask,
    VueTelInput
  },
  data() {
    return {
      phoneNumber: "",
      name: null,
      email: null,
      isFormSend: false,
      formSend,
      hexTokens: {
        F: {
          pattern: /[0-9]/
        }
      },
      bindProps2: {
        onlyCountries: ["SE", "NO", "DK"],
        disabledFetchingCountry: true,
        dropdownOptions: {
          disabledDialCode: false
        },
        inputOptions: {
          showDialCode: false
        },
        maxLen: 20,
        validCharactersOnly: true,
        wrapperClasses: 'small-phone'
      }
    };
  },
  validations: {
    // Название поля должно совпадать с полем в data
    phoneNumber: {
      required,
      maxLength: maxLength(20),
      minLength: minLength(7)
    },
    email: {
      required,
      email
    },
    name: {
      required,
      maxLength: maxLength(25),
      minLength: minLength(3)
    }

  },

  methods: {
    delayTouch($v) {
      $v.$reset();
    },
    changeLocation() {
      // const local = 'http://localhost:8080/';
      // const dev = 'http://nordic-dev.os-system.com/';
      // const prod = 'https://nordic.os-system.com/';
      // if(window.location.href === local) {
      //   window.location = `${local}thank-you`;
      // } else if (window.location.href === dev) {
      //   window.location = `${dev}thank-you`;
      // } else {
      //   window.location = `${prod}thank-you`;
      // }
      window.location = `${window.location.href}thank-you`;
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // const data = {
        //   name: this.name,
        //   phoneNumber: this.phoneNumber,
        //   email: this.email
        // };
        await axios.post(`${process.env.VUE_APP_API_LINK}/api/form`, {
          site: 'nordic',
          name: this.name,
          phoneNumber: this.phoneNumber,
          email: this.email,
        }, { headers: { ...authHeader() }});
        this.changeLocation();
        // this.showMessage();
      }
    },
    showMessage() {
      this.isFormSend = true;
      setTimeout(() => {
        this.isFormSend = false;
        this.$emit("clickReset");
      }, 2000);
      this.resetData();
    },
    changeDialProp() {
      this.bindProps2.inputOptions.showDialCode = true;
      console.log(this.bindProps2.inputOptions.showDialCode)
    },
    resetData() {
      this.name = null;
      this.phoneNumber = null;
      this.email = null;
      this.$v.$reset();
    }
  },
  mounted() {
    var $vm = this;

      $('.small-phone .vti__input').on('focus', function() {
        $vm.changeDialProp();
        $('.small-phone .vti__dropdown').css({display: 'flex'})
        if ($('.small-phone .vti__selection div').hasClass('se')) {
           $('.small-phone .vti__input').val('+46')
        } else if ($('.small-phone .vti__selection div').hasClass('dk')) {
           $('.small-phone .vti__input').val('+45')
        } else if ($('.small-phone .vti__selection div').hasClass('no')) {
           $('.small-phone .vti__input').val('+47')
        }
      })
      $('.small-phone .vti__dropdown').click(function() {
        $('.small-phone .vti__input').focus()
      })
  },
};
</script>

<style scoped lang="scss">
.header-form {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media screen and (max-width: 1012px) {
    left: -22px;
    top: -27px;
  }
}

.header-input-container {
  margin-bottom: 20px;
  position: relative;

  &:last-child {
    margin: 0;
  }
  @media screen and (max-width: 1130px) {
    margin-bottom: 15px;
  }

  @media screen and (max-width: 1012px) {
    width: 68%;
    margin-bottom: 10px;
  }
}

.header-form-error {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  width: 281px;
  height: 16px;
  font-size: 10px;
  line-height: 12px;
  background: url("../assets/img/error-back.svg");
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 0 0 12px 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #ffffff;
  box-sizing: border-box;
  z-index: 3;

  @media screen and (max-width: 1130px) {
    background: url("../assets/img/error-back-1130.svg");
    width: 221px;
    height: 14px;
    background-size: contain;
    background-repeat: no-repeat;
  }

  @media screen and (max-width: 1012px) {
    width: 176px;
    height: 12px;
    font-size: 8px;
    line-height: 9px;
    bottom: -8px;
  }

  @media screen and (max-width: 767px) {
    width: 352px;
    height: 18px;
    font-size: 12px;
    line-height: 14px;
  }
}

.header-with-text {
  background: #ffffff !important;
  border: 2px solid #f2f2f2 !important;
  box-sizing: border-box;
}

.without-text {
  // box-shadow: none !important;
}

.header-form-big-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: 900;
  font-size: 40px;
  line-height: 100%;
  text-align: center;
  color: #21252e;
  max-width: 246px;
  margin: 80px auto 30px;
  @media screen and (max-width: 1130px) {
    font-size: 30px;
    line-height: 100%;
    max-width: 193px;
    margin-top: 58px;
    margin-bottom: 23px;
  }

  @media screen and (max-width: 1012px) {
    font-size: 28px;
    max-width: 176px;
    margin-top: 47px;
    margin-bottom: 15px;
  }
}

.header-form-small-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 20px;
  text-align: center;
  color: #1899e1;

  @media screen and (max-width: 1130px) {
    font-size: 19px;
    line-height: 20px;
  }

  @media screen and (max-width: 1012px) {
    font-size: 17px;
    line-height: 20px;
  }
}

.header-form-letter {
  @media screen and (max-width: 1130px) {
    width: 100%;
  }

  @media screen and (max-width: 1012px) {
    width: 80%;
    top: -46px;
    left: 4px;
    position: relative;
  }
}

.form-send {
  position: absolute;
  top: 29%;
  left: 1%;
  @media screen and (max-width: 1130) {
    img {
      width: 100%;
    }
  }
  @media screen and (max-width: 1012) {
    img {
      width: 80%;
      top: -46px;
      left: 4px;
      position: relative;
    }
  }
}

.input-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 43px;
  margin-bottom: 41px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: 1130px) {
    margin-top: 23px;
  }

  @media screen and (max-width: 1012px) {
    margin-top: 15px;
    margin-bottom: 20px;
  }
}

.header-input {
  width: 288px;
  height: 56px;
  left: 219px;
  top: 2708px;
  background: #f5f5f5;
  border-radius: 55px;
  text-align: center;
  border: none;
  outline: none;
  margin: 0;
  box-sizing: border-box;
  -webkit-appearance: none;

  &:focus {
    background-color: white;
    border: 2px solid #F2F2F2;
  }

  @media screen and (max-width: 1130px) {
    width: 230px;
    height: 50px;
    font-size: 16px;
    // margin-bottom: 15px;

    line-height: 19px;
  }

  @media screen and (max-width: 1012px) {
    width: 100%;
    height: 45px;
    font-size: 14px;
    line-height: 16px;
    padding: 0 !important;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.header-form-btn {
  position: absolute;
  width: 286px;
  height: 60px;
  top: 545px;
  left: 24px;
  background: #1899e1;
  border-radius: 40px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
   -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;

  @media screen and (min-width: 769px) {
    &:hover {
      background: #26b1ff;
      box-shadow: 0px 0px 15px #26b1ff;
    }

    &:active {
      background: #1187ca;
      box-shadow: none !important;
    }

    // &:focus {
    //   box-shadow: none !important;
    // }
  }

  @media screen and (max-width: 1130px) {
    width: 230px;
    height: 50px;
    font-size: 16px;
    line-height: 19px;
    top: 439px;
    left: 23px;
  }

  @media screen and (max-width: 1012px) {
    width: 186px;
    height: 45px;
    font-size: 14px;
    line-height: 16px;
    top: 357px;
    left: 45px;
  }
}
</style>


<style lang="scss">
  #app .vue-tel-input.small-phone{
    outline: none;
    border: none;
    outline-offset: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    box-shadow:none;
    border: 2px solid #F5F5F5;
    -webkit-box-shadow: none;
    position: relative;
    top: 0;
    left: 0;

      &:focus {
        box-shadow:none;
        -webkit-box-shadow: none;
      }
  }

  #app .vue-tel-input.small-phone:focus-within {
    background-color: #ffffff;
    border: 1px solid #F5F5F5;

    .vti__input {
      background-color: #ffffff;
    }

  }

  #app .small-phone .vti__dropdown {
    // border: 2px solid #F5F5F5;
    display: none;
    padding: 0;
    width: 59px !important;
    height: 100%;
    border-top-left-radius: 27px;
    border-bottom-left-radius: 27px;
    position: absolute;
    z-index: 2;
    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);

    @media screen and (max-width: 769px) {
      width: 52px !important;
    }


  }

    #app .small-phone .vti__dropdown::after {
    content: '';
    width: 2px;
    height: 70%;
    margin: auto;
    background-color:#F2F2F2;
    position: absolute;
    right: 0;
  }


  #app .small-phone .vti__selection {
    justify-content: center;

    span {
      display: none;
    }
  }

  #app .small-phone .vti__input {
    width: 100%;
    margin: auto;
    outline: none !important;
    border: none !important;
    background-color : transparent;
    text-align: center;
    border-radius: 50px;

    &:focus, &:active {
      background-color: transparent;
    }

    &::placeholder {
      color: #21252E;
      opacity: 0.7;
    }

  }

  #app .small-phone .vti__dropdown-list {
    width: 100%;
    top: -2px;
    left: -3px;
    border-top-left-radius: 32px;
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
    max-height: none;
    overflow-y: hidden;
    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);

    strong, span {
      display: none;
    }

     &:focus {
      box-shadow:none;
      -webkit-box-shadow: none;
    }


    @media screen and (max-width: 1130px) {
      border-top-left-radius: 31px;
    }
  }

  #app .small-phone .vti__dropdown-item {
    height: 53px;
    padding: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    background: #D4EFFF;
    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);


    @media screen and (max-width: 1130px) {
      height: 46px;
    }

    @media screen and (max-width: 1012px) {
      height: 41px;
    }
  }

  #app .small-phone .vti__dropdown-item:nth-child(1) {
    border-top-left-radius: 24px;

    @media screen and (max-width: 1130px) {
      border-top-left-radius: 20px;
    }
  }

  #app .vti__dropdown-item.highlighted {
      background-color: #ffffff;
  }

  #app .vti__flag {
    background-image: none;
    background-size: cover;
    background-color: transparent;
    box-shadow: none;
  }

  #app .small-phone .vti__flag.se {
    background-image: url('../assets/img/sweeden-flag.svg');
    background-position: center;
    width: 23px;
    height: 16px;
    background-size: cover;
    background-color: transparent;
    box-shadow: none;
  }

  #app .small-phone .vti__flag.no {
    background-image: url('../assets/img/norway-flag.svg');
    background-position: center;
    width: 23px;
    height: 16px;
    background-size: cover;
    background-color: transparent;
    box-shadow: none;
  }

  #app .small-phone .vti__flag.dk {
    background-image: url('../assets/img/denmark-flag.svg');
    background-position: center;
    width: 23px;
    height: 16px;
    background-size: cover;
    background-color: transparent;
    box-shadow: none;
  }

</style>
